'use client'
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from '#/renderer/router';

import UI from './Search.ui';
import { addonsList } from '~/store/Addons/Addons';

class Search extends Component {

  constructor(props) {
    super(props);
    this.state = ({
      productList: [],
      addonsList: [],
    });
  }

  componentDidMount() {
    this.addonsList();
    document.getElementById('initial').scrollIntoView(true);
    this.productList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.productList();
    }
  }

  addonsList() {
    addonsList().then((res) => {
      if (res.success) {
        this.setState({
          addonsList: res.data[0].filter(x => x.enabled === true && x.show_home === false),
          currentPage: 1,
        });
      }
    });
  }

  productList() {
    const { keyword: kw } = this.props.params;
    const keyword = decodeURIComponent(kw);
    this.props.catalogStore.search({ keyword }).then((res) => {
      this.setState({ searchResult: res, keyword });
    });
  }

  render() {
    const searchResult = this.state.searchResult;
    let productList = [];
    if (searchResult && searchResult.data && searchResult.data.data) {
      productList = searchResult.data.data.filter(prod => +prod.type <= 6);
    }

    return (
      <UI
        productList={productList}
        addonsList={this.state.addonsList}
        categorySlugSearch={this.props.location.pathname}
        searchResult={this.state.searchResult}
        keyword={this.state.keyword}
      />
    );
  }
}

export default inject('catalogStore')(observer(withRouter(Search)));
